/**
 * Muestra mensajes de éxito o error en un popup animado
 */
document.addEventListener('DOMContentLoaded', function() {
    // Verificar que existe la configuración global
    if (typeof GesvaltFormulariosConf === 'undefined') {
        console.log('GesvaltFormulariosConf no está definido');
        return;
    }
    
    console.log('🔍 Checking popup messages...');
    console.log('Error message:', GesvaltFormulariosConf.form_error_message);
    console.log('Success message:', GesvaltFormulariosConf.form_success_message);
    
    const formError = GesvaltFormulariosConf.form_error_message;
    const formSuccess = GesvaltFormulariosConf.form_success_message;
    
    // Función helper para validar si es una cadena válida
    const isValidString = (str) => {
        return typeof str === 'string' && str.trim() !== '';
    };
    
    // Solo mostrar si hay un mensaje real (no vacío)
    if (isValidString(formError) || isValidString(formSuccess)) {
        const popup = document.createElement('div');
        popup.className = 'gesvalt-formularios-popup';
        
        // Determinar tipo y mensaje
        if (isValidString(formSuccess)) {
            popup.textContent = formSuccess;
            popup.classList.add('success');
            console.log('✅ Showing success popup:', formSuccess);
        } else if (isValidString(formError)) {
            popup.textContent = formError;
            popup.classList.add('error');
            console.log('❌ Showing error popup:', formError);
        }
        
        // Añadir al DOM
        document.body.appendChild(popup);
        console.log('📝 Popup added to DOM:', popup);

        // Mostrar con animación
        setTimeout(() => {
            popup.classList.add('show');
            console.log('🎬 Popup animation started');
        }, 100);

        // Ocultar después de 4 segundos
        setTimeout(() => {
            popup.classList.remove('show');
            console.log('🎬 Popup hiding animation started');
            
            // Eliminar del DOM después de la animación
            setTimeout(() => {
                if (popup.parentNode) {
                    popup.remove();
                    console.log('🗑️ Popup removed from DOM');
                }
            }, 300);
        }, 6000);
    } else {
        console.log('ℹ️ No popup messages to show');
        console.log('formError type:', typeof formError, 'value:', formError);
        console.log('formSuccess type:', typeof formSuccess, 'value:', formSuccess);
    }
});
